import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaRocket, FaAngleUp, FaBrain, FaLaptopCode, FaLightbulb } from 'react-icons/fa';
import { Stack } from '@mui/material';
import './timeline.css'; // Add the custom styles separately
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Timeline = () => {

      useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true,     // whether animation should happen only once
      offset: 100,    // trigger point (px) before element enters viewport
    });
  }, []);

  return (
    <div data-aos="slide-up" >
    <VerticalTimeline className='timeline'  >
      <VerticalTimelineElement
        className="vertical-timeline-element--work"
contentStyle={{
  background: "linear-gradient(to top, rgba(255, 255, 255, 0.15) 20%, rgba(255, 255, 255, 0.05) 80%)",
  backdropFilter: "blur(10px)",
  borderRadius: '16px',
  padding: '15px',
  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
}}
        contentArrowStyle={{ borderRight: '7px solid rgba(33, 150, 243, 0.3)' }}
        date="2017"
        dateClassName='timeline-date'
        iconStyle={{ background: '#2196f3', color: '#fff' }}
        icon={<FaLightbulb />}
       
      >
        {/* Example: Replace with your actual image path or remove if not needed */}
        
        <div className="timeline-card"  style={{padding:"10px"}}>
            <Stack direction={"row"}>
            {/* <img src={require("../../../assets/Horizon_logo_192x192.png")} alt="Company Established" style={{ width: '75px', height: 'auto' }}/> */}
          <h1 className="timeline-title" style={{fontSize:"1.8rem"}}>Company Established</h1></Stack>
          <h3 className="timeline-subtitle" style={{fontSize:"1.35rem",marginTop:"15px"}}>Bangalore, Karnataka</h3>
          <p className="timeline-text" style={{fontSize:"1.1rem"}}>
            Focusing on OTT platforms, we started our journey building streaming solutions.
          </p>
        </div>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
contentStyle={{
  background: "linear-gradient(to top, rgba(255, 255, 255, 0.15) 20%, rgba(255, 255, 255, 0.05) 80%)",
  backdropFilter: "blur(10px)",
  borderRadius: '16px',
  padding: '15px',
  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
}}
        contentArrowStyle={{ borderRight: '7px solid rgba(33, 150, 243, 0.3)' }}
        date="2019-2020"
        iconStyle={{ background: '#2196f3', color: '#fff' }}
        icon={<FaRocket />}
      >
        <div className="timeline-card"  style={{padding:"10px"}}>
          <h1 className="timeline-title" style={{fontSize:"1.8rem"}}>Expansion</h1>
          <h3 className="timeline-subtitle" style={{fontSize:"1.35rem"}}>Developed an Ed-Tech Solution</h3>
           <p className="timeline-text" style={{fontSize:"1.1rem"}}>
            Moved into the educational technology domain.
          </p>
        </div>
      </VerticalTimelineElement>

       <VerticalTimelineElement
        className="vertical-timeline-element--work"
contentStyle={{
  background: "linear-gradient(to top, rgba(255, 255, 255, 0.15) 20%, rgba(255, 255, 255, 0.05) 80%)",
  backdropFilter: "blur(10px)",
  borderRadius: '16px',
  padding: '15px',
  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
}}
        contentArrowStyle={{ borderRight: '7px solid rgba(33, 150, 243, 0.3)' }}
        date="2020-2021"
        iconStyle={{ background: '#2196f3', color: '#fff' }}
        icon={<FaAngleUp/>}
      >
        <div className="timeline-card"  style={{padding:"10px"}}>
          <h1 className="timeline-title" style={{fontSize:"1.8rem"}}>Product Diversification</h1>
          <h3 className="timeline-subtitle" style={{fontSize:"1.35rem"}}>Enterprise Solution</h3>
          <p className="timeline-text" style={{fontSize:"1.1rem"}}>
            Launched a UX Manager for enterprise clients.
          </p>
        </div>
      </VerticalTimelineElement>

       <VerticalTimelineElement
        className="vertical-timeline-element--work"
contentStyle={{
  background: "linear-gradient(to top, rgba(255, 255, 255, 0.15) 20%, rgba(255, 255, 255, 0.05) 80%)",
  backdropFilter: "blur(10px)",
  borderRadius: '16px',
  padding: '15px',
  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
}}
        contentArrowStyle={{ borderRight: '7px solid rgba(33, 150, 243, 0.3)' }}
        date="2022-2023"
        iconStyle={{ background: '#2196f3', color: '#fff' }}
        icon={<FaLaptopCode />}
      >
        <div className="timeline-card"  style={{padding:"10px"}}>
         <h1 className="timeline-title" style={{fontSize:"1.8rem"}}>AI Strategy</h1>
         <h3 className="timeline-subtitle" style={{fontSize:"1.35rem"}}>Automation Rollout</h3>
         <p className="timeline-text" style={{fontSize:"1.1rem"}}>
            AI tools launched for operational efficiency.
          </p>
        </div>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
contentStyle={{
  background: "linear-gradient(to top, rgba(255, 255, 255, 0.15) 20%, rgba(255, 255, 255, 0.05) 80%)",
  backdropFilter: "blur(10px)",
  borderRadius: '16px',
  padding: '15px',
  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
}}
        contentArrowStyle={{ borderRight: '7px solid rgba(33, 150, 243, 0.3)' }}
        date="2024-2025"
        iconStyle={{ background: '#2196f3', color: '#fff' }}
        icon={<FaBrain />}
      >
        <div className="timeline-card" style={{padding:"10px"}}>
          <h1 className="timeline-title" style={{fontSize:"1.8rem"}}>R&D Solutions</h1>
          <h3 className="timeline-subtitle" style={{fontSize:"1.35rem"}}>Launched in Bangalore</h3>
          <p className="timeline-text" style={{fontSize:"1.1rem"}}>
            Opened our R&D center in Bangalore to boost innovation.
          </p>
        </div>
      </VerticalTimelineElement>
    </VerticalTimeline>
    </div>
  );
};

export default Timeline;
